export const FMTS = { Physical: "📖", "E-Book": "📱", Audiobook: "🎧" };

export const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const MONTHS_FULL = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const FICTION_GENRES = [
  "Fantasy",
  "Dark Fantasy",
  "Sci-Fi",
  "Romance",
  "Suspense",
  "Satire",
  "Thriller",
  "Mystery",
  "Horror",
  "Contemporary",
  "Historical Fiction",
  "Literary Fiction",
  "Adventure",
  "Young Adult",
  "Graphic Novel",
  "Manga",
  "Classic",
];

export const NONFIC_GENRES = [
  "Biography",
  "Memoir",
  "Self-Help",
  "Personal Development",
  "Technology",
  "Political Science",
  "Social Science",
  "Psychology",
  "Health & Wellness",
  "Business",
  "History",
  "True Crime",
  "Science",
  "Sociology",
  "Philosophy",
  "Spirituality",
  "Parenting",
  "Cultural Studies",
  "Environment",
  "Poetry",
  "Humor",
  "Children's",
];

export const VIBES = [
  "Aliens",
  "Anthology",
  "Apocalyptic",
  "Character Study",
  "Cozy",
  "Dark",
  "Dark Academia",
  "Dark Romance",
  "Dragon",
  "Dystopian",
  "Epic Fantasy",
  "Fae",
  "Fanfic",
  "Feel Good",
  "Funny",
  "Gothic",
  "High Fantasy",
  "Holiday",
  "LGBT+",
  "Literary Tearjerker",
  "Magical Realism",
  "Medieval",
  "MM Romance",
  "Mythology",
  "Novella",
  "Paranormal",
  "Political Intrigue",
  "Psychological",
  "Quirky",
  "Revenge",
  "Rom-Com",
  "Romantasy",
  "Sapphic",
  "Satire",
  "Scary",
  "Space Opera",
  "Sports Romance",
  "Steampunk",
  "Supernatural",
  "Surreal",
  "Suspense",
  "Thriller-y",
  "Time Travel",
  "Translated",
  "Twisty",
  "Urban Fantasy",
  "Vampire",
  "Weird",
  "Werewolf",
  "Witches",
];

export const FUN_STUFF = [
  "Chosen One",
  "Enemies to Lovers",
  "Fake Dating",
  "Fast Burn",
  "Forced Proximity",
  "Found Family",
  "Friends to Lovers",
  "Morally Grey",
  "Second Chance",
  "Slow Burn",
  "Small Town",
  "Spicy 🌶️",
  "Workplace Romance",
];

export const ALL_VIBES = [...new Set([...VIBES, ...FUN_STUFF])];

export const GOOGLE_GENRE_RULES = [
  {
    patterns: ["science fiction", "sci-fi", "science fiction & fantasy"],
    label: "Sci-Fi",
  },
  { patterns: ["fantasy", "epic fantasy", "high fantasy"], label: "Fantasy" },
  {
    patterns: ["comics", "graphic novels", "graphic novel"],
    label: "Graphic Novel",
  },
  { patterns: ["manga"], label: "Manga" },
  {
    patterns: ["juvenile fiction", "young adult fiction", "ya fiction"],
    label: "Young Adult",
  },
  { patterns: ["mystery", "detective"], label: "Mystery" },
  { patterns: ["horror", "ghost stories", "horror tales"], label: "Horror" },
  { patterns: ["thriller", "thrillers"], label: "Thriller" },
  { patterns: ["suspense", "suspense fiction"], label: "Suspense" },
  { patterns: ["romance"], label: "Romance" },
  { patterns: ["historical fiction"], label: "Historical Fiction" },
  {
    patterns: ["literary criticism", "literary collections", "literary fiction"],
    label: "Literary Fiction",
  },
  { patterns: ["classics", "classic literature"], label: "Classic" },
  {
    patterns: ["contemporary", "contemporary fiction", "general fiction"],
    label: "Contemporary",
  },
  {
    patterns: ["adventure", "action", "action & adventure"],
    label: "Adventure",
  },
  {
    patterns: ["business", "economics", "business & economics"],
    label: "Business",
  },
  { patterns: ["juvenile nonfiction"], label: "Children's" },
  { patterns: ["body, mind & spirit", "spirituality"], label: "Spirituality" },
  { patterns: ["self-help"], label: "Self-Help" },
  {
    patterns: ["personal development", "self improvement", "personal growth"],
    label: "Personal Development",
  },
  {
    patterns: ["health", "fitness", "medical", "wellness"],
    label: "Health & Wellness",
  },
  { patterns: ["technology", "engineering", "computers"], label: "Technology" },
  { patterns: ["political science"], label: "Political Science" },
  { patterns: ["social science"], label: "Social Science" },
  { patterns: ["true crime"], label: "True Crime" },
  { patterns: ["psychology"], label: "Psychology" },
  { patterns: ["philosophy"], label: "Philosophy" },
  { patterns: ["biography", "autobiography"], label: "Biography" },
  { patterns: ["memoir"], label: "Memoir" },
  { patterns: ["history"], label: "History" },
  { patterns: ["nature", "science", "math"], label: "Science" },
  { patterns: ["parenting", "family"], label: "Parenting" },
  {
    patterns: ["health & wellness", "health and wellness"],
    label: "Health & Wellness",
  },
  { patterns: ["cultural studies", "culture"], label: "Cultural Studies" },
  { patterns: ["environment", "environmental"], label: "Environment" },
  { patterns: ["sociology"], label: "Sociology" },
  { patterns: ["humor", "comedy"], label: "Humor" },
  { patterns: ["satire", "satirical fiction"], label: "Satire" },
  { patterns: ["poetry"], label: "Poetry" },
];

export const ALLOWED_GENRES = new Set(
  GOOGLE_GENRE_RULES.map((rule) => rule.label),
);

export const AVATARS = [
  "✨",
  "🐉",
  "🌙",
  "💌",
  "🖤",
  "🌹",
  "🥀",
  "❤️‍🔥",
  "🌧️",
  "🛋️",
  "🍵",
  "☕️",
  "🕯️",
  "📚",
  "📖",
  "🤓",
  "🧠",
  "📝",
];
